import { PropertyValueResource } from "../../../client/resources/index";
const isBound = (value: PropertyValueResource, fallback = true) => {
    if (value) {
        return (value as string).includes("#{");
    }
    return fallback;
};

export default isBound;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/form/BoundField/isBound.ts